<template>
    <b-form-group :label="label"
        :invalid-feedback="errorTxt"
        :state="state">
        <b-form-file
            v-model="inputVal"
            :accept="accept"
            :state="state"
            :placeholder="placeholder"
            @input="change"
            >
        </b-form-file>
    </b-form-group>
</template>

<script>
    export default {
        props: {
            service: String,
            model: Object,
            attribute: String,
            attributeFileName: String,
            attributeFileType: String,
            label: String,
            placeholder: String,
            errors: Array,
            accept: String,
            maxSize: {
                type: Number,
                default: 10
            },
            errorOnly: Boolean
        },
        data() {
            return {inputVal: null, state: null, errorTxt: ''}
        },
        methods: {
            change() {
                this.state = null;
                this.errorTxt = null;
                this.model[this.attribute] = null;
                if (this.inputVal) {
                    if (this.accept && !this.accept.split(',').includes(this.inputVal.type)) {
                        this.state = false;
                        this.errorTxt = 'Invalid file type';
                    } else if (this.inputVal.size / (1024 * 1024) > this.maxSize) {
                        this.state = false;
                        this.errorTxt = 'Max file size exceeded';
                    } else if (this.service && this.service !== '') {
                        this.saveLoading = true;
                        const formData = new FormData();
                        formData.append('file', this.inputVal);
                        this.$service.post(this.service, formData).then(response => {
                            this.model[this.attribute] = response.data;
                            if (this.attributeFileName) {
                                this.model[this.attributeFileName] = this.inputVal.name;
                            }
                            if (this.attributeFileType) {
                                this.model[this.attributeFileType] = this.inputVal.type;
                            }
                        }).finally(() => {
                            this.saveLoading = false;
                        });
                    } else {
                        this.model[this.attribute] = this.inputVal;
                    }
                }
            },
        },
        watch: {
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
    }
</script>